import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-doctors-section',
  templateUrl: './doctors-section.component.html',
  styleUrl: './doctors-section.component.scss'
})
export class DoctorsSectionComponent   implements OnInit{

  @Input()
  public doctors: Array<any> = [];
  public    user: any;

  constructor() {
  }

  ngOnInit(): void {
    if(this.doctors?.length > 0){
      this.doctors.forEach(doctor => {
        if (doctor.image ) {
          doctor.image = `data:image/jpeg;base64,${doctor.image}`;
        }
      })
    }

  }
}
